const oidc = {
    logout_success: 'Bạn đã đăng xuất thành công.',
};
export default Object.freeze(oidc);
